// Not used directly, this is just combining null and undefined for us
type None = null | undefined;

// used similarly to `Maybe` found in this repo
export type Nullable<T> = T | None;

// typeguards to ensure values are defined or not
export const isNone = <T>(nullable: Nullable<T>): nullable is None =>
  nullable === null || nullable === undefined;

export const isSome = <T>(nullable: Nullable<T>): nullable is T =>
  !isNone(nullable);

export type NeverObject = Record<never, never>;

export type NoRequestArgs = NeverObject;
